var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hideHeaderFooterArr.includes(_vm.$route.path))?_c('Header'):_vm._e(),_c('router-view'),(!_vm.hideHeaderFooterArr.includes(_vm.$route.path))?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }